module.exports = __webpack_public_path__ + "img/upload.24768749.svg";